import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  EtapeScenarioState,
  loadEtapeScenariosAction,
  loadEtapeScenariosSuccessAction,
} from './etape.store';
import { EtapeService } from '../../_services/http/etape.service';

@Injectable()
export class EtapeScenarioEffect {
  constructor(
    private service: EtapeService,
    private actions$: Actions,
    private store: Store<EtapeScenarioState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEtapeScenariosAction),
      mergeMap((action) =>
        this.service.all().pipe(
          map((payload) => loadEtapeScenariosSuccessAction({ payload })),
          catchError(() => EMPTY)
        )
      )
    )
  );
}
